import classNames from 'classnames';

import { useWindowSize } from '@/hooks/index';

import styles from './ImageMask.module.scss';

const ImageMask = ({ children, className, desktop, mobile }) => {
  const [x] = useWindowSize();

  const maskImage = {
    desktop: `url(${desktop || '/assets/image-masks/big-star-2.png'})`,
    mobile: `url(${mobile || '/assets/image-masks/big-star.png'})`,
  };

  return (
    <div
      style={{
        WebkitMaskImage: x > 1024 ? maskImage.desktop : maskImage.mobile,
        maskImage: x > 1024 ? maskImage.desktop : maskImage.mobile,
      }}
      className={classNames([styles.mask, className])}
      itemScope
      itemType='http://schema.org/ImageObject'
    >
      {children}
    </div>
  );
};

export default ImageMask;
